import React from 'react'
import styled from 'styled-components'
import { SIZE } from '../../const';

import vertialImg from '../../images/ads/fcc-vertical-300x600.png'

export const VerticalBannerAd = ({ override_ad }) => {
  if (override_ad) {
    return (
      <Wrapper>
        <a href={override_ad.link} target={override_ad.target} title={override_ad.alt}>
          <img src={`/support-center/api/${override_ad.media_file.url}`} alt={override_ad.alt} />
          {override_ad.impression_pixel ? <img src={override_ad.impression_pixel} style={{ display: 'none' }} alt='impression pixel' /> : false}
        </a>
      </Wrapper>
    )
  }
  else {
    return (
      <Wrapper>
        <a href="https://www.freeconferencecall.com/how-people-use-free-conference-call?campaign_tag=FCC20_REC_ADD_0001" target="_blank" rel="noreferrer" title="FreeConferenceCall.com Signup">
          <img src={vertialImg} alt="FreeConferenceCall signup page" />
        </a>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  margin-bottom: 15px;
  img {
    width: 100%;
  }
  @media ${SIZE.categorySwitch} {
    display: none;
  }
`
